/**
 * Debug-mode enable flag (009).
 *
 * ON iff URL has `?debug=1` OR sessionStorage['webrtc:debug']==='1'. `?debug=1`
 * persists the flag for the tab session (survives reloads within the tab, but
 * auto-clears when the tab closes — debug never silently stays on forever);
 * `?debug=0` clears it. Default OFF. Evaluated once at module load — everything
 * costly in the debug module is gated on this, so disabled = inert (FR-001/FR-009).
 */
const STORAGE_KEY = 'webrtc:debug'

function readPersisted(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/** Apply a `?debug=0|1` URL override (persisting it). Returns the override, or null if absent. */
function applyUrlOverride(): boolean | null {
  try {
    const params = new URLSearchParams(window.location.search)
    if (!params.has('debug')) return null
    const on = params.get('debug') !== '0'
    try {
      sessionStorage.setItem(STORAGE_KEY, on ? '1' : '0')
    } catch {
      /* storage unavailable — fall back to the URL value for this load */
    }
    return on
  } catch {
    return null
  }
}

let cached: boolean | null = null

export function isDebugEnabled(): boolean {
  if (cached !== null) return cached
  const override = applyUrlOverride()
  cached = override !== null ? override : readPersisted()
  return cached
}
